<app-navbar></app-navbar>
<div  id="outage">
    <div *ngIf="outagebol" class="container" id="form">
      <div class="title">DevOps Outage Form</div>
      <div class="content">
        <form action="#" (submit)="preview($event)" >
          <div class="user-details">
            <div class="input-box">
              <span class="details">Outage</span>
              <input type="text" placeholder="Enter the Type Of Outage" required id="outage-form" [(ngModel)]="outageinputval.outage" name="outage" />
            </div>
            <div class="input-box">
              <span class="details">Environment</span>
              <select id="environment" name="Environment" [(ngModel)]="outageinputval.environment" (change)="email()" name="environment">
                <option value="Dev" >Dev</option>
                <option value="Beta">Beta</option>
                <option value="QA">QA</option>
                <option value="Stage">Stage</option>
                <option value="IDay">IDay</option>
                <option value="MC4MA">MC4MA</option>
                <option value="MC4EA">MC4EA</option>
                <option value="MC4TC">MC4TC</option>
                <option value="MC4OC">MC4OC</option>
                <option value="MC4BW">MC4BW</option>
                <option value="MC4MB">MC4MB</option>
              </select>
            </div>
            <div class="input-box">
              <span class="details">What</span>
              <input type="text" placeholder="What" required id="what" [(ngModel)]="outageinputval.what" name="what" />
            </div>
            <div class="input-box">
              <span class="details">When</span>
              <input type="text" placeholder="When" required id="when" [(ngModel)]="outageinputval.when" name="when" />
            </div>
            <div class="input-box">
              <span class="details">Next Update</span>
              <input type="text" placeholder="Next Update" required id="nextUpdate" [(ngModel)]="outageinputval.nextupdate" name="nextupdate" />
            </div>
            <div class="input-box">
              <span class="details">Impact</span>
              <input type="text" placeholder="Mention the Impacts" required id="impact" [(ngModel)]="outageinputval.impact" name="impact" />
            </div>
            <div class="input-box">
              <span class="details">To Email Address</span>
              <input type="text" placeholder="Mention the Team" required id="email" [(ngModel)]="emails" name="emailadress" value={{emails}} />
            </div>
            <div class="input-box">
              <span class="details">Template-ID</span>
              <!-- <input type="" placeholder="Template-ID" required id="template-id" [(ngModel)]="outageinputval.templateid" name="templateid" /> -->
              <select id="template-id" name="Template-ID" [(ngModel)]="outageinputval.templateid" (change)="email()" name="templateid">
               <option value="d-13341c7b223e406491c302aa4a89db8f">Outage Template</option>
               <option value="d-b9ad0226b2a34e16898038adf4c54569">Outage Template RN</option>
              </select>
            </div>
            <div class="input-box">
              <span class="details">From-Email ID</span>
              <input type="text" placeholder="FromEmail-ID" required id="from-email" [(ngModel)]="outageinputval.fromemailid" name="fromemailid" />
            </div>
            <div class="input-box">
              <span class="details">Email Subject</span>
              <input type="text" placeholder="Enter the Subject" required id="subject" [(ngModel)]="outageinputval.emailsubject" name="emailsubject" />
            </div>
            <div class="input-box">
              <span class="details">Release Notes Link</span>
              <input type="text" placeholder="Release Notes Link" required id="weblink" [(ngModel)]="outageinputval.weblink" name="weblink" />
            </div>
          </div>
          <div class="button">
            <input type="submit" value="Preview" id="submit" />
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="previewbol" class="container" id="preview">
      <h3>Outage</h3>
      <p id="outage-preview">{{outageinputval.outage}}</p>

      <h3>Environment</h3>
      <p id="env-preview">{{outageinputval.environment}}</p>

      <h3>What</h3>
      <p id="what-preview">{{outageinputval.what}}</p>

      <h3>when</h3>
      <p id="when-preview">{{outageinputval.when}}</p>

      <h3>next update</h3>
      <p id="next-update-preview">{{outageinputval.nextupdate}}</p>

      <h3>Impact</h3>
      <p id="impact-preview">{{outageinputval.impact}}</p>


      <h3>Template-ID</h3>
      <p id="templateid-preview">{{outageinputval.templateid}}</p>

      <h3>From Email-ID</h3>
      <p id="FromEmailID-preview">{{outageinputval.fromemailid}}</p>

      <h3>To Email-ID</h3>
      <p id="ToEmailID-preview">{{emails}}</p>

      <h3>Email Subject</h3>
      <p id="EmailSubject-preview">{{outageinputval.emailsubject}}</p>

      <h3>Release Notes</h3>
      <p id="releasenotes-preview">{{outageinputval.weblink}}</p>

      <form action="#" (submit)="sendemail()">
        <div class="button">
          <input (click)="goback()" type="submit" value="Go Back" id="back" />
        </div>
        <div *ngIf="!loading"  class="button" >

          <input type="submit" value="Send Email" id="send-email" />
        </div>
        <div *ngIf="loading" class="loadingbtn">
          <button class="btn btn-primary button" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Sending Email...
          </button>
        </div>
        <div id="outage-response" *ngIf="statusAvailable">
          <span>Status</span>
          {{returndata}}
          <span>{{responseMessage}}</span>
        </div>
      </form>
    </div>
  </div>
